<template>
  <pt-adult-out-stock class="pt-adult-out-stock__page"></pt-adult-out-stock>
</template>

<script>
import PtAdultOutStock from 'cps/adult-stocks-manage/pt-adult-out-stock/withData'
export default {
  name: 'pt-adult-out-stock__view',
  components: {
    'pt-adult-out-stock': PtAdultOutStock
  }
}
</script>
